// VelvetGate platform-default branding fallbacks.
//
// Precedence rules (handled at display time — we never mutate stored records):
//
//   EVENT IMAGE (rectangular):
//     1. event.event_image_url  (host-uploaded per-event flyer)
//     2. DEFAULT_EVENT_IMAGE    (platform default)
//
//   ORGANIZER LOGO (square):
//     1. event.organizer_logo_url (event-specific logo)
//     2. The host's saved default is already copied onto new events at
//        creation time (see CreateEvent.js), so by the time an event is
//        stored, the host-saved default is present in event.organizer_logo_url
//        whenever the host had one.
//     3. DEFAULT_ORGANIZER_LOGO  (platform default)
//
// Defaults live as static files under /app/frontend/public/defaults/ so they
// ship with the frontend bundle and never hit the backend.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const DEFAULT_EVENT_IMAGE = '/defaults/event-default.png';
export const DEFAULT_ORGANIZER_LOGO = '/defaults/logo-default.png';

/** Returns a ready-to-use <img src> for the event flyer, falling back to the
 * platform default when no host image is on the record. */
export function getEventImageSrc(event) {
  const url = event?.event_image_url;
  return url ? `${BACKEND_URL}${url}` : DEFAULT_EVENT_IMAGE;
}

/** Returns a ready-to-use <img src> for the organizer logo, falling back to
 * the platform default. Also returns `isDefault` so callers can tweak layout
 * (e.g. to drop "bg-white" padding that conflicts with the dark default). */
export function getOrganizerLogoSrc(event) {
  const url = event?.organizer_logo_url;
  if (!url || typeof url !== 'string') {
    return { src: DEFAULT_ORGANIZER_LOGO, isDefault: true };
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return { src: DEFAULT_ORGANIZER_LOGO, isDefault: true };
  }
  // Absolute URLs (http://, https://, //cdn) — use as-is to avoid double-prefix.
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) {
    return { src: trimmed, isDefault: false };
  }
  // Data URIs pass through
  if (trimmed.startsWith('data:')) {
    return { src: trimmed, isDefault: false };
  }
  return { src: `${BACKEND_URL}${trimmed}`, isDefault: false };
}
